module.exports = __webpack_public_path__ + "img/KinokoTable29.a72677e8.jpg";